export const ENVIRONMENT_TOKENS_FLAG = 'environment_tokens';

type RuntimePanelKey =
  | 'fleetMenu'
  | 'simulationResults'
  | 'generateRides'
  | 'fixedRoutes'
  | 'dataTransfer'
  | 'attributeTable'
  | 'populationAnalysis'
  | 'spatialAnalysis'
  | 'bugReport';

export const RUNTIME_PANEL_FEATURES: Partial<Record<RuntimePanelKey, string | readonly string[]>> = {
  simulationResults: 'simulation_results_analytics',
  generateRides: 'generate_rides',
  fixedRoutes: 'fixed_routes',
  dataTransfer: ['data_transfer_drawer', ENVIRONMENT_TOKENS_FLAG],
  attributeTable: 'attribute_table',
  populationAnalysis: 'population_analysis',
  // spatialAnalysis intentionally NOT mapped here: it uses a "fail-open" gate
  // (visible unless an admin explicitly disables `spatial_analysis` for a
  // customer) rather than the default-off panel gating, so it stays visible
  // before the flag row is seeded. See MapSidebar / MapContextMenusManager.
};

export function isPanelRuntimeEnabled(
  key: RuntimePanelKey,
  isFeatureRuntimeEnabled: (flagName: string) => boolean
): boolean {
  const features = RUNTIME_PANEL_FEATURES[key];
  if (!features) return true;
  const required = typeof features === 'string' ? [features] : features;
  return required.every((flagName) => isFeatureRuntimeEnabled(flagName));
}
